// Se carga en todas las páginas; si algún otro archivo lo vuelve a cargar, no se ejecuta dos veces.
if (!window.__tcScripts) {
window.__tcScripts = true;

function tcArrancar() {
  initReveal();
  initGaleriaProducto();
  initCantidadProducto();
  initVariantesProducto();
  initTraduccionResenas();
  initBotonMercadoPago();
  initPopupMp();
}

// Aviso en una esquina "Paga con Mercado Pago y consigue 5% OFF": no bloquea la página; si se cierra queda una etiqueta pequeña para reabrirlo.
function initPopupMp() {
  var cont = document.querySelector('[data-tc-popup-mp]');
  if (!cont) return;
  document.body.appendChild(cont); // así position:fixed no depende de ningún contenedor con transform
  if (document.querySelector('[data-lp-sticky], [data-tcp-sticky]')) cont.classList.add('con-barra'); // sube el aviso para no tapar la barra de compra del teléfono
  var clave = 'tcPopupMpMin';
  var minimizado = false;
  try { minimizado = sessionStorage.getItem(clave) === '1'; } catch (e) {}
  var botonMp = document.querySelector('form[data-tc-producto-form] .tc-pdp__comprar--mercadopago');
  var comprar = cont.querySelector('[data-tc-popup-mp-comprar]');
  if (comprar && (!botonMp || botonMp.disabled)) comprar.style.display = 'none';
  var caja = cont.querySelector('.tc-popup-mp__caja');
  function mostrar(abierto) {
    cont.classList.toggle('is-abierto', abierto);
    cont.classList.toggle('is-minimizado', !abierto);
    if (caja) caja.setAttribute('aria-hidden', abierto ? 'false' : 'true');
  }
  function guardar(v) { try { sessionStorage.setItem(clave, v ? '1' : '0'); } catch (e) {} }
  cont.hidden = false;
  cont.querySelectorAll('[data-tc-popup-mp-cerrar]').forEach(function (el) {
    el.addEventListener('click', function () { mostrar(false); guardar(true); });
  });
  var abrirBtn = cont.querySelector('[data-tc-popup-mp-abrir]');
  if (abrirBtn) abrirBtn.addEventListener('click', function () { mostrar(true); guardar(false); });
  if (comprar) {
    comprar.addEventListener('click', function () {
      mostrar(false);
      if (botonMp && !botonMp.disabled) botonMp.click();
    });
  }
  if (minimizado) mostrar(false);
  else setTimeout(function () { mostrar(true); }, 1800);
}


// "COMPRA AHORA" (Mercado Pago): crea un carrito APARTE con el código de 5% y lleva directo al pago.
// Así el carrito de la sesión (el que lee el pago contra entrega de Releasit) nunca recibe el descuento.
var TC_CODIGO_MP = ''; // sin código: el 5% de Mercado Pago se quitó (2026-10-01)
function initBotonMercadoPago() {
  document.querySelectorAll('form[data-tc-producto-form]').forEach(function (form) {
    var boton = form.querySelector('.tc-pdp__comprar--mercadopago');
    if (!boton || boton.__tcMp) return;
    boton.__tcMp = true;
    boton.addEventListener('click', function (e) {
      if (boton.disabled || !window.fetch) return; // sin fetch se usa el envío normal del formulario
      var idEl = form.querySelector('input[name="id"]');
      var qEl = form.querySelector('input[name="quantity"]');
      if (!idEl || !idEl.value) return;
      e.preventDefault();
      var qty = Math.max(1, parseInt(qEl && qEl.value, 10) || 1);
      var texto = boton.querySelector('[data-tc-boton-texto]');
      var original = texto ? texto.textContent : '';
      boton.disabled = true;
      if (texto) texto.textContent = 'Un momento…';
      var consulta = 'mutation($i:CartInput!){cartCreate(input:$i){cart{checkoutUrl}userErrors{message}}}';
      fetch('/api/2025-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: consulta, variables: { i: { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + idEl.value, quantity: qty }], discountCodes: TC_CODIGO_MP ? [TC_CODIGO_MP] : [] } } })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var c = d && d.data && d.data.cartCreate && d.data.cartCreate.cart;
          if (c && c.checkoutUrl) { window.location.href = c.checkoutUrl; return; }
          throw new Error('sin carrito');
        })
        .catch(function () {
          // Plan B: el envío normal del formulario (lleva el código en la dirección del pago).
          boton.disabled = false;
          if (texto) texto.textContent = original;
          if (form.requestSubmit) form.requestSubmit(boton); else form.submit();
        });
    });
  });
}

// Traducciones fieles al español de reseñas importadas que llegaron en otro idioma.
// Clave = texto original (minúsculas, espacios normalizados). Si se vuelve a importar la reseña en español, esto deja de aplicarse solo.
var TC_RESENAS_ES = {
  "as shown. fits in the designated place. looks good and very sturdy.": "Como se ve en las fotos. Cabe en el lugar previsto. Se ve bien y es muy firme.",
  "excellent product, much more than i imagined. you don\u0027t need any tools to assemble it, i highly recommend it!": "¡Excelente producto, mucho más de lo que imaginaba! No necesitas ninguna herramienta para armarlo. ¡Lo recomiendo mucho!",
  "super quality materials and assembly! easy to assemble and install, all parts are made very well, nothing wobbles or dangles. the drain works perfectly. recommend!": "¡Materiales y armado de súper calidad! Es fácil de armar e instalar, todas las piezas están muy bien hechas, nada se mueve ni cuelga. El drenaje funciona perfectamente. ¡RECOMIENDO!",
  "everything is great, exactly as shown on the website. well-packaged, easy to assemble, very convenient and compact dryer. i recommend both the product and the seller. thank you! 😍👍": "Todo es genial, tal como se ve en la página. Bien embalado, fácil de armar, un escurridor muy cómodo y compacto. Recomiendo tanto el producto como al vendedor. ¡Gracias! 😍👍",
  "this product exceeded my expectations and i am very satisfied. the position where the drying rack is placed needs to be flat for water to drain well, but in our house it feels slightly tilted, so i lift it up and empty it every once in a while when washing dishes.": "Este producto superó mis expectativas y estoy muy satisfecho. El lugar donde se coloca el escurridor debe ser plano para que el agua drene bien, pero en nuestra casa queda un poco inclinado, así que lo levanto y lo vacío de vez en cuando mientras lavo los platos.",
  "really great! feels quite sturdy and is able to hold an impressive amount of dishes relative to the space it takes on the counter. couldn\u0027t be happier.": "¡Realmente genial! Se siente bastante firme y puede sostener una cantidad impresionante de platos para el espacio que ocupa en el mesón. No podría estar más feliz.",
  "when i opened the box, i felt that the product quality was not good, but when i actually used it, it turned out to be quite good.": "Cuando abrí la caja sentí que la calidad del producto no era buena, pero al usarlo resultó ser bastante bueno.",
  "honestly? pleasantly surprised! very spacious, feels sturdy. whether it will last long we\u0027ll have to see.": "¿La verdad? ¡Gratamente sorprendido! Muy espacioso, se siente firme. Habrá que ver si dura mucho tiempo.",
  "great product, large and convenient with a knife stand and water drainage and waste disposal system.": "Gran producto, grande y cómodo, con soporte para cuchillos y sistema de drenaje de agua y de eliminación de residuos.",
  "it seems that having space to place small dishes on one side of the kitchen sink has made space utilization more efficient.": "Parece que tener espacio para colocar platos pequeños a un lado del fregadero de la cocina ha hecho que el aprovechamiento del espacio sea más eficiente.",
  "good design, good quality. best recommendations.": "Buen diseño, buena calidad. Muy recomendado.",
  "very very satisfied. quality item, well made, comfortable, holds a lot. arrived perfectly packaged. totally recommend": "Muy, muy satisfecho. Artículo de calidad, bien hecho, cómodo, le cabe mucho. Llegó perfectamente embalado. Totalmente recomendado.",
  'highly recommend seller highly recommend seller': 'Recomiendo mucho al vendedor. Recomiendo mucho al vendedor.',
  'very good and useful product': 'Muy buen producto y muy útil.',
  'very good': 'Muy bueno.',
  'спасибо за оперативность! веса добрались за 13 дней! удобней конечно же через приложение пользоватся нежели в самих весах листать и искать нужный продукт, а в приложении в поиске ввёл, нашёл и готово) нужно докупить 4 батарейки типа aaa.': '¡Gracias por la rapidez! ¡La balanza llegó en 13 días! Es más cómodo usarla con la aplicación que desplazarse por la propia balanza buscando el producto: en la aplicación escribes en el buscador, lo encuentras y listo. Hay que comprar 4 pilas AAA.',
  'гарний товар , через додаток все конектиться без проблем будемо тестувати і дивитися як себе покаже далі': 'Buen producto. Con la aplicación todo se conecta sin problemas. Lo seguiremos probando y veremos cómo se desempeña más adelante.'
};
// Reseñas que no se muestran (texto original, minúsculas). Motivo: menciona un plazo de entrega que no corresponde a Chile.
var TC_RESENAS_OCULTAS = {
  "everything was perfect, it took about 10 days to arrive in spain, it came very well packaged, the only downside is that you have to assemble it and the instructions are not clear 🤣 but you look at the photo in the ad and it\u0027s easy to assemble.": true,
  'спасибо за оперативность! веса добрались за 13 дней! удобней конечно же через приложение пользоватся нежели в самих весах листать и искать нужный продукт, а в приложении в поиске ввёл, нашёл и готово) нужно докупить 4 батарейки типа aaa.': true
};
// Fotos de reseñas que no se muestran (parte del nombre del archivo): racks de otro color y la hoja de instrucciones.
var TC_FOTOS_OCULTAS = [
  'Abc7297366d0243e58a572d6a6632d1a5L', // rack blanco
  'A60a04dff7b164efcaae20781de080054n', // rack blanco
  'A3253d1d54a5e46dc973c037eb7c92529q', // rack rosado
  'A84a5232abd514e9eb738b2665739d1e5r'  // hoja de instrucciones de armado
];
function tcOcultarFotosResenas() {
  document.querySelectorAll('.jdgm-widget img, .jdgm-review-widget img, .jm-media-thumbnail-list img, .jdgm-gallery img, [class*="jdgm"] img').forEach(function (img) {
    var src = img.currentSrc || img.src || '';
    if (!TC_FOTOS_OCULTAS.some(function (k) { return src.indexOf(k) !== -1; })) return;
    var caja = img.closest('.jm-media-thumbnail-list__thumbnail, .jdgm-rev__pic, .jdgm-gallery__thumbnail-link, .jm-frame, a') || img;
    caja.style.display = 'none';
  });
  document.querySelectorAll('[style*="background-image"]').forEach(function (el) {
    var st = el.getAttribute('style') || '';
    if (TC_FOTOS_OCULTAS.some(function (k) { return st.indexOf(k) !== -1; })) el.style.display = 'none';
  });
}
function tcNormTexto(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
function tcTraducirResenas() {
  tcOcultarFotosResenas();
  var nodos = document.querySelectorAll('.jdgm-widget p, .jdgm-review-widget p, .jm-review-content__body p, .jdgm-review-content__body-content, .jdgm-carousel-item *');
  nodos.forEach(function (el) {
    if (el.children.length) return;
    var clave = tcNormTexto(el.textContent);
    if (TC_RESENAS_OCULTAS[clave]) {
      var caja = el.closest('.jm-review-item, .jdgm-rev, .jdgm-carousel-item, .jdgm-review-list > *');
      if (caja) caja.style.display = 'none';
    }
    var t = TC_RESENAS_ES[clave];
    if (t) { el.textContent = t; el.setAttribute('lang', 'es'); }
  });
}
function initTraduccionResenas() {
  tcTraducirResenas();
  if (!('MutationObserver' in window)) return;
  var pendiente = false;
  new MutationObserver(function () {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(function () { pendiente = false; tcTraducirResenas(); });
  }).observe(document.body, { childList: true, subtree: true });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tcArrancar);
} else {
  tcArrancar();
}

function initReveal() {
  var els = document.querySelectorAll('.tc-reveal, .tc-reveal-stagger');
  if (!els.length) return;
  function mostrarTodo() {
    els.forEach(function (el) { el.classList.add('tc-visible'); });
    document.documentElement.classList.remove('tc-anim');
  }
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    mostrarTodo();
    return;
  }
  // Si el script funciona, ya no hace falta el seguro que muestra todo a los 5 s.
  clearTimeout(window.__tcAnimTimer);
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('tc-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0, rootMargin: '0px 0px -4% 0px' });
  els.forEach(function (el) { observer.observe(el); });
  // Seguro extra: si el observador no reacciona, a los 7 s se muestra todo para que nunca quede una página en blanco.
  setTimeout(mostrarTodo, 7000);
}

function tcCambiarFoto(galeria, src) {
  var principal = galeria.querySelector('[data-tc-galeria-principal]');
  if (!principal || !src) return;
  principal.src = src;
  galeria.querySelectorAll('[data-tc-miniatura]').forEach(function (m) {
    m.classList.toggle('is-activa', m.getAttribute('data-full') === src);
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('[data-tc-galeria]').forEach(function (galeria) {
    var miniaturas = galeria.querySelectorAll('[data-tc-miniatura]');
    var tira = galeria.querySelector('[data-tc-miniaturas]');

    miniaturas.forEach(function (mini) {
      mini.addEventListener('click', function () {
        tcCambiarFoto(galeria, mini.getAttribute('data-full'));
      });
    });

    galeria.querySelectorAll('[data-tc-flecha]').forEach(function (flecha) {
      flecha.addEventListener('click', function () {
        if (!tira) return;
        var dir = parseInt(flecha.getAttribute('data-tc-flecha'), 10);
        tira.scrollBy({ left: dir * tira.clientWidth * 0.8, behavior: 'smooth' });
      });
    });

    // Visor de imagen ampliada
    var principalWrap = galeria.querySelector('[data-tc-abrir-visor]');
    var pdp = galeria.closest('[data-tc-pdp]') || document;
    var visor = pdp.querySelector('[data-tc-visor]');
    if (!principalWrap || !visor) return;
    var visorImg = visor.querySelector('[data-tc-visor-img]');
    function abrir() {
      var img = galeria.querySelector('[data-tc-galeria-principal]');
      if (!img) return;
      visorImg.src = img.src;
      visor.classList.add('is-abierto');
      visor.setAttribute('aria-hidden', 'false');
    }
    function cerrar() {
      visor.classList.remove('is-abierto');
      visor.setAttribute('aria-hidden', 'true');
    }
    principalWrap.addEventListener('click', abrir);
    visor.addEventListener('click', function (e) {
      if (e.target === visor || e.target.hasAttribute('data-tc-cerrar-visor')) cerrar();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });
  });
}

function initCantidadProducto() {
  document.querySelectorAll('.tc-pdp__cantidad').forEach(function (caja) {
    var input = caja.querySelector('[data-tc-cantidad-input]');
    if (!input) return;
    caja.querySelectorAll('[data-tc-cantidad]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-tc-cantidad'), 10);
        var actual = parseInt(input.value, 10) || 1;
        input.value = Math.max(1, actual + dir);
      });
    });
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      input.value = isNaN(v) || v < 1 ? 1 : v;
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('[data-tc-producto-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-tc-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var pdp = form.closest('[data-tc-pdp]') || document;
    var galeria = pdp.querySelector('[data-tc-galeria]');
    var inputId = form.querySelector('input[name="id"]');
    var precioEl = pdp.querySelector('[data-tc-precio]');
    var tachadoEl = pdp.querySelector('[data-tc-precio-tachado]');
    var botones = form.querySelectorAll('[data-tc-boton-comprar]');
    var grupos = form.querySelectorAll('[data-tc-opcion]');

    function actualizar() {
      var seleccion = Array.prototype.map.call(grupos, function (grupo) {
        var activo = grupo.querySelector('.is-seleccionado');
        return activo ? activo.getAttribute('data-valor') : null;
      });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;

      if (inputId) inputId.value = variante.id;

      var oferta = variante.compare_at_price && variante.compare_at_price > variante.price;
      if (precioEl) {
        precioEl.textContent = variante.price_fmt;
        precioEl.classList.toggle('es-oferta', !!oferta);
      }
      if (tachadoEl) {
        if (oferta) {
          tachadoEl.textContent = variante.compare_fmt;
          tachadoEl.style.display = '';
        } else {
          tachadoEl.style.display = 'none';
        }
      }
      botones.forEach(function (boton) {
        var botonTexto = boton.querySelector('[data-tc-boton-texto]');
        var botonPrecio = boton.querySelector('[data-tc-boton-precio]');
        boton.disabled = !variante.available;
        if (boton.hasAttribute('data-tc-oculto-agotado')) boton.hidden = !variante.available;
        if (botonTexto) {
          botonTexto.textContent = variante.available
            ? boton.getAttribute('data-texto-disponible')
            : boton.getAttribute('data-texto-agotado');
        }
        if (botonPrecio) {
          botonPrecio.textContent = '· ' + variante.price_fmt;
          botonPrecio.style.display = variante.available ? '' : 'none';
        }
      });
      if (galeria && variante.image) tcCambiarFoto(galeria, variante.image);
    }

    grupos.forEach(function (grupo) {
      var valorEl = grupo.querySelector('[data-tc-opcion-valor]');
      grupo.querySelectorAll('[data-valor]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('[data-valor]').forEach(function (b) { b.classList.remove('is-seleccionado'); });
          btn.classList.add('is-seleccionado');
          if (valorEl) valorEl.textContent = btn.getAttribute('data-valor');
          actualizar();
        });
      });
    });

    actualizar();
  });
}

} // fin de la protección contra doble carga
